<template>
	<div class="container mx-auto">
		<header class="mx-auto mb-8 mt-4 flex max-w-screen-xl justify-center px-4 text-center">
			<h1 class="flex items-center justify-center text-title-xl">
				<span class="rounded-full overflow-hidden w-10 h-10 inline-block mr-2"><img
						src="@/assets/favicon-96x96.png" alt="Logo Rendom Tattoo"></span>
				<a href="/">Rendom_Tattoo</a>
			</h1>
		</header>

		<router-view />

	</div>
</template>
